// extracted by mini-css-extract-plugin
module.exports =  {"infoIcon":"mKceEegrkUR_Wx8FtfYS"};